export default "__VITE_ASSET__8e12d35a__"